import React from "react";
import { useNavigate } from "react-router-dom";

const Button = ({ buttonText, cancelButton, onClickHandler }) => {
  const buttonClass = cancelButton
    ? "join_room_cancel_button"
    : "join_room_success_button";

  return (
    <button className={buttonClass} onClick={onClickHandler}>
      {buttonText}
    </button>
  );
};

const JoinRoomButtons = ({ handleJoinToRoom, isRoomHost }) => {
  const successButtonText = isRoomHost ? "Host" : "Join";
  const navigate = useNavigate();
  const pushToDashboard = () => {
    navigate("/");
    // window.location.reload();
  };

  return (
    <div className="join_room_buttons_container">
      <Button
        buttonText={successButtonText}
        onClickHandler={handleJoinToRoom}
      />

      <Button
        buttonText="cancel"
        cancelButton
        onClickHandler={pushToDashboard}
      />
    </div>
  );
};

export default JoinRoomButtons;
